export const Links = {
  MainSite: 'https://getfastbar.com',
  ContactUs: 'https://getfastbar.com/request-demo',
  Privacy: 'https://getfastbar.com/privacy',
  Terms: 'https://getfastbar.com/terms-of-service'
} as const;

export type LinkKey = keyof typeof Links;

